module.exports = __webpack_public_path__ + "media/images/application/template/cc-home-bkg-2500px-54ed9caf7a18f4d324d81015943659d8.jpg";